import type { Asset } from '@/components/asset-manager/types';
import http from '@/lib/http';

export async function downloadUnsplashImage(photoId: string): Promise<Asset & { url: string }> {
  const response = await http.post('/unsplash/download', { photoId });
  const asset = response.data as Asset;

  if (!asset?.url) {
    throw new Error('Invalid asset response');
  }

  return asset as Asset & { url: string };
}
